import sImg1 from '../images/testimonial/1.jpg'
import sImg2 from '../images/testimonial/2.jpg'
import sImg4 from '../images/testimonial/5.jpg'
import sImg5 from '../images/testimonial/7.jpg'
import sImg6 from '../images/testimonial/6.jpg'




const testimonials = [
    {
        id: '01',
        img: sImg1,
        Des: "OFL has transformed how we manage freight across multiple regions. Their team keeps our shipments on schedule, offers clear tracking, and delivers competitive pricing without compromising service quality.",
        title: 'Robert J. Hare',
        sub: "Freight Manager",
    },
    {
        id: '02',
        img: sImg2,
        Des: "We rely on OFL for warehousing and last-mile delivery. From pickup to proof of delivery, their logistics support is reliable, responsive, and easy to work with every single time.",
        title: 'Winifred P. Reyes',
        sub: "Logistics Coordinator",
    },
    {
        id: '03',
        img: sImg4,
        Des: "Our supply chain runs smoother since partnering with OFL. Ocean and road freight are coordinated efficiently, and their proactive updates help us avoid costly delays at the port.",
        title: 'Daniel M. Carter',
        sub: "Supply Chain Lead",
    },
    {
        id: '04',
        img: sImg5,
        Des: "OFL handles our transportation with real care. On-time deliveries, careful cargo handling, and transparent communication make them a trusted logistics partner for our business.",
        title: 'Sarah K. Nguyen',
        sub: "Operations Manager",
    },
    {
        id: '05',
        img: sImg6,
        Des: "From customs support to final delivery, OFL provides end-to-end logistics we can count on. Their pricing is fair, and their team consistently goes the extra mile for our freight needs.",
        title: 'Michael T. Brooks',
        sub: "Import Manager",
    },

]


export default testimonials;
